import React from 'react';

const SubscriptionNoteTable = () => {
  return (
    <div className="subscriptionNoteTableContainer">
      <table>
        <thead>
          <tr>
            <th>取消時期（旅行開始日前日から起算してさかのぼって）</th>
            <th>取消料金</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>〜55日前</td>
            <td>航空便1区間につき500円</td>
          </tr>
          <tr>
            <td>54日前〜21日前</td>
            <td>航空便1区間につき2,000円</td>
          </tr>
          <tr>
            <td>20日前〜8日前</td>
            <td>旅行代金の20%</td>
          </tr>
          <tr>
            <td>7日前〜2日前</td>
            <td>旅行代金の30%</td>
          </tr>
          <tr>
            <td>前日</td>
            <td>旅行代金の40%</td>
          </tr>
          <tr>
            <td>当日</td>
            <td>旅行代金の50%</td>
          </tr>
          <tr>
            <td>旅行開始後の解除または不参加</td>
            <td>旅行代金の100%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SubscriptionNoteTable;
